import Api from "./Api";

class StationLocationService {
    getStationLocation = async (probeId, locationId) => {
        return await Api().get(`probe/${probeId}/location/${locationId}`, )
    }

    updateStationLocationVariables = async (probeId, locationId, variables) => {
        return await Api().put(`/probe/${probeId}/location/${locationId}/variables`, {
            sensor_variables: variables
        })
    }
}

export default new StationLocationService();